"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireLoanPayoffDate = void 0;
const date_fns_1 = require("date-fns");
const idr_1 = require("../../constants/idr");
/**
 * This function contains the business logic to determine if we need a loan's payoff date in order
 * to calculate an IDR recommendation.
 *
 * To be eligible for PAYE and IBR plans you must be a "new borrower", which is defined as having
 * no balance on a Direct or FFEL loan on a certain date, which differs for each
 * plan.
 *
 * Therefore, we require the loan payoff date if a loan is paid off and if it is a Direct or FFEL
 * (non parent-plus) loan.
 * We also check that if it is a consolidation loan, the consolidation did not include a parent plus
 * loan.
 *
 * For more information, see FSA:
 * @param {string} disbursementDate - The date the loan was received by the borrower.
 * @param {boolean} loanTypeRequiresPayoffDate - Whether a loan is a Direct/FFEL non-parent-plus
 *  loan.
 * @param {boolean | null} includesParentPlus - If a consolidation loan includes a parent plus loan.
 *   Should be null for non-consolidation loans.
 * @param {number} principalBalance - The current principal balance of the loan
 */
const requireLoanPayoffDate = (disbursementDate, // dateonly string, YYYY-MM-DD
loanTypeRequiresPayoffDate, includesParentPlus, principalBalance) => {
    const loanIsPaidOff = principalBalance === 0;
    const takenOutBeforeNewBorrowerDate = (0, date_fns_1.isBefore)(new Date(disbursementDate), new Date(idr_1.IBR_NEW_BORROWER_DATE));
    const consolidationDidNotIncludeParentPlus = includesParentPlus !== true;
    return (loanIsPaidOff &&
        takenOutBeforeNewBorrowerDate &&
        loanTypeRequiresPayoffDate &&
        consolidationDidNotIncludeParentPlus);
};
exports.requireLoanPayoffDate = requireLoanPayoffDate;
